import * as yup from 'yup';
const validateSignInForm = yup.object({
  email: yup.string().email('Email must be a valid email').required('Email is a required field'),
  password: yup
    .string()
    .required('Password is a required field')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      'Must contain 12 characters or more, one uppercase, one lowercase, one number and one special case character'
    )
});

export default validateSignInForm;
